export type GoogleGtag = (...args: unknown[]) => void;

export const GOOGLE_GTAG_SCRIPT_BASE =
  'https://www.googletagmanager.com/gtag/js';
